import { createStorage } from './createStorage';

const storage = createStorage();

export { storage };
export type { SecureStoreAdapter } from '@/adapters/storage/types';
